<template>
  <div class="hotelMapApp">
    <GmapMap
      :center="{ lat: latitude, lng: longitude }"
      :zoom="zoom"
      :options="mapOptions"
    >
      <GmapMarker
        :position="{ lat: latitude, lng: longitude }"
        :clickable="true"
        :draggable="true"
        @click="center = m.position"
      />
    </GmapMap>
    <a
      :href="`https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`"
      target="_blank"
      aria-label="地図アプリ"
      class="hotelBtnMini"
      >Googleマップでみる
      <tk-icon name="open_link" class="icoOpenLink"></tk-icon>
    </a>
  </div>
</template>

<script>
import TkIcon from '../../atoms/TkIcon/TkIcon'

const DEFAULT_MAP_OPTIONS = {
  clickableIcons: true,
  disableDoubleClickZoom: false,
  draggable: true,
  mapMaker: true,
  fullscreenControl: false,
  zoomControl: false,
  mapTypeControl: false,
  mapTypeId: 'roadmap',
  streetViewControl: false,
  styles: [
    {
      featureType: 'administrative.land_parcel',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'poi',
      elementType: 'labels.text',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'poi.business',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'road',
      elementType: 'labels.icon',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'road.arterial',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'road.highway',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'road.local',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'road.local',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'transit',
      stylers: [{ visibility: 'off' }],
    },
  ],
}

export default {
  name: 'TkHotelMap',
  components: { TkIcon },
  props: {
    latitude: {
      type: Number,
      required: true,
    },
    longitude: {
      type: Number,
      required: true,
    },
    zoom: {
      type: Number,
      default: 13,
    },
    mapOptions: {
      type: Object,
      default: () => DEFAULT_MAP_OPTIONS,
    },
  },
}
</script>

<style lang="scss">
@import '@ota-frontend/ui/src/scss/components/TkHotelMap.scss';
</style>
